import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { AzureFilesUploaderControlled } from '../../../../components/AzureFilesUploader/AzureFileUploaderControlled';
import { SectionTitle } from '../../../../components/text';
import { useSIESConfig } from '../../../../hooks/useSIESConfig';
import { CurriculumValues } from '../../../../types/CurriculumTypes';
import CurriculumFormContentSies from './CurriculumFormContentSies';

type CurriculumFormContentBottomProps = {
  readOnly: boolean;
};

const CurriculumFormContentBottom = ({
  readOnly,
}: CurriculumFormContentBottomProps) => {
  const { control } = useFormContext<CurriculumValues>();
  const prefix = 'studyPlans.curriculum';
  const { t } = useTranslation();

  const { siesEnabled } = useSIESConfig();

  return (
    <>
      <Row xs={12} className="pb-5 pt-5">
        <Col xs={12} md={6}>
          <SectionTitle text={t(`${prefix}.curriculumImage.title`)} />
          <span className="fs-16">
            {t(`${prefix}.curriculumImage.description`)}
          </span>
        </Col>
        <Col xs={12} md={6}>
          <AzureFilesUploaderControlled
            name="curriculumImage"
            control={control}
            accept={['images']}
            label={t(`${prefix}.curriculumImage.inputTitle`)}
            btnText={t(`${prefix}.curriculumImage.inputBtn`)}
            disabled={readOnly}
          />
        </Col>
      </Row>

      {siesEnabled && <CurriculumFormContentSies />}
    </>
  );
};

export default CurriculumFormContentBottom;
